<template>
  <div>
    <modal name="modalEditOrder" classes="main-modal" :adaptive="true" :width="width" :height="height"
    @before-open="beforeOpen"
    @opened="opened">
      <div class="modal-header">
        <h2 class="modal-header-title">주문정정</h2>
        <button @click="closeModify()"><img src="@/assets/icons/icon-close-modal.svg" alt="" /></button>
      </div>

      <div class="modal-body">
        <div class="modal-edit-order">
          <div class="order-input-group">
            <div class="order-input-container">
              <label for="">가격</label>
              <input type="text" :value="stdOrdPrc" placeholder="가격" @input="checkEditOrdPrc($event)" />
              <div class="unit">USDT</div>
            </div>

            <div class="order-input-container">
              <label for="">수량</label>
              <input type="text" :value="stdOrdQty" placeholder="수량" @input="checkEditOrdQty($event)" />
              <div class="unit">{{ stdOrdType }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <!-- <button class="btn-primary darkgray" @click="closeModal()">취소</button> -->
        <button class="btn-primary blue" @click="modifyOrder()">확인</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Utils from '@/modules/utils';

export default {
  name: 'CoinModalEditOrder',

  data() {
    return {
      width: '',
      height: '',
      modifyData: null,
      stdOrdPrc: '',
      stdOrdQty: '',
      stdOrdType: 'BTC',
      coinSymbolInfo: null,
      coinSymbol: null,
      cocData: null,
    };
  },

  created() {
    if (window.innerWidth > 1200) {
      this.width = 500;
      this.height = 240;
    } else {
      this.width = '100%';
      this.height = '100%';
    }
  },

  mounted() {},

  methods: {
    opened(){
      
    },
    async beforeOpen(e){
      console.log("beforeOpen e.prams", e.params)

      const dataMap = await window.$http.get('apisisecoin/getCocData', { params: { } })

      const cocData = dataMap.data.cocDataList;
      // const comData = dataMap.data.comDataList;

      

      this.modifyData = e.params;

      if (cocData != null){
        this.cocData = cocData[this.modifyData.symCd];
      }

      // 초기화
      this.stdOrdPrc = 0;
      this.stdOrdQty = 0;
      this.coinSymbol = null;
      this.coinSymbolInfo = null;

      //종목정보
      const coinSymbolList = window.$store.getters['Symbol/getCoinSymbolList'];
      coinSymbolList.forEach(item => {
        if (item.symbolno == this.modifyData.symNo){
          this.coinSymbol = item;
          return;
        }
      });

      //이전 가격 수량 설정
      this.stdOrdPrc = e.params.execPrc;
      this.stdOrdQty = e.params.balQty;
      
      if (this.coinSymbol != null){
        this.stdOrdPrc = this.stdOrdPrc.toFixed(this.tikDotSz(this.coinSymbol));
      }      

      const coinSymbolInfoList = window.$store.getters['Symbol/getCoinSymbolInfoList']

      for (let item of coinSymbolInfoList) {
        if (item.symNo == this.modifyData.symNo) {
          this.coinSymbolInfo = item;
          this.stdOrdType = item.artcCd;
          break;
        }
      }

      let message = "코인 체결리스트 미체결 정정 클릭 "+ e.params.symCd;
      this.sendCoinOmsLogMessage(message);

      
    },
    closeModal() {
      this.$modal.hide('modalEditOrder');
    },
    closeModify(){
      let message = "코인 체결리스트 미체결 정정 닫기 클릭 "+ this.modifyData.symCd;
      this.sendCoinOmsLogMessage(message);
      this.closeModal();
    },
    modifyOrder(){
      if (this.stdOrdTpCd == "1" && (!this.stdOrdPrc || this.stdOrdPrc <= 0)){
        window.$alert.alert('가격을 입력 해주세요.', '알림');
        return;
      }
      
      if (!this.stdOrdQty || this.stdOrdQty <= 0){
        window.$alert.alert('수량을 입력 해주세요.', '알림');
        return;
      }

      let ordQty = 0;
      let minOrdQty = this.coinSymbolInfo.minTrdAmt; //db에서 읽어와야함
      let minOrdPrc = this.coinSymbolInfo.minOrdPrc; //최소 입력 가격

      //수량에 USDT로 입력할 경우 BTC 수량으로 계산
      if (this.stdOrdType == "USDT"){
        ordQty = Utils.coinUsdtToBtc(this.stdOrdQty, this.coinNowPrice.curPr, minOrdQty);
      }else{
        ordQty = this.stdOrdQty;
      }

      //최소가격 체크
      if (Number(this.stdOrdPrc) < Number(minOrdPrc)){
        window.$alert.alert('주문가능 최소('+minOrdPrc+' USDT) 가격을 확인 해주세요.', '알림');
        return;
      }

      //BTC 최소 수량 가능한지 체크
      if (ordQty < minOrdQty){
        //console.log("ordQty, minOrdQty ", ordQty, minOrdQty)
        window.$alert.alert('주문가능 최소 수량을 확인 해주세요.', '알림');
        return;
      }

      //포지션 지정가 청산일경우 체크
      if (this.modifyData.posSeq != undefined && this.modifyData.posSeq > 0){
        let posOrdSlList = window.$store.getters['SocketCoinOms/getCoinPosOrdStList'];
        //console.log("posOrdSlList ", posOrdSlList)
        let modOrdQty = Number(ordQty);

        //포지션 주문 수량 구하기
        let balQty = 0;
        for (let item of posOrdSlList){
          if (item.ordType == "POS" && item.posSeq == this.modifyData.posSeq){
            balQty = item.balQty;
          }
        }

        //미체결 수량 포지션 최대 수량 체크
        for (let item of posOrdSlList){
          if (item.ordType == "ORD" && item.posSeq != undefined && item.ordQty != undefined && item.ordId > 0 && this.modifyData.ordId != item.ordId && this.modifyData.posSeq == item.posSeq){
            //modOrdQty += modOrdQty + Number(item.ordQty);
            modOrdQty = Utils.decimalAdd(modOrdQty, item.ordQty);
          }
        }

        //console.log("modOrdQty ", Number(modOrdQty), Number(balQty))
        if (Number(modOrdQty) > Number(balQty)){
          window.$alert.alert('포지션 수량을 초과 할 수 없습니다.<br/>(미체결 청산 수량 포함)', '알림');
          return;
        }
      }else{
      //일반 주문 수량 가능 수량 체크
        // 1. 저장된 수량, 2. 구매 가능한 수량
        // 3. 1 += 신규수량 > 2 보다 크면 불가 메시지 추가
        let maxSellBuyQty = 0;
        let cms = this.coinSymbolInfo.lmtCmsR;

        //코인 종목의 티어리스트
        let coinSymbolLeverageList = window.$store.getters['Symbol/getCoinSymbolLeverageList'];
        let coinTier = coinSymbolLeverageList.get(this.modifyData.symCd);

        //유저 레버리지, 마진모드, 거래모드
        let usrPos = window.$store.getters['SocketCoinOms/getUsrPos'];       
        let coinLeverage = this.modifyData.lv;
        let buffer = usrPos.buffer;
        //유저 보유금액정보
        let coinDailyPlMn = Object.assign({}, window.$store.getters['SocketCoinOms/getCoinDailyPlMn']);

        //기존 가격 + 수량에 대한 금액 산정
        let orgOrdPrc = Utils.decimalMultiply(this.modifyData.execPrc, this.modifyData.balQty);
        let orgOrdLvPrc = Utils.decimalDivide(orgOrdPrc, coinLeverage);

        const cmsR = Utils.decimalDivide(cms, 100); //수수료율
        const ableLvUsdtCms = Utils.decimalMultiply(orgOrdPrc, Utils.decimalAdd(1, cmsR));

        let orgUseUsdtVal = Utils.decimalAdd(orgOrdLvPrc, Utils.decimalMultiply(orgOrdPrc, cmsR));
        orgUseUsdtVal = Utils.decimalFloorVal(orgUseUsdtVal, 4);

        let orgUseUsdt = Utils.decimalSubtract(coinDailyPlMn.orgUseUsdt, orgUseUsdtVal);
        
        let useUsdt = Utils.decimalSubtract(coinDailyPlMn.useUsdt, ableLvUsdtCms);

        let ableUsdt = Utils.decimalAdd(coinDailyPlMn.ableUsdt, orgUseUsdtVal);

        //미체결 수량을 usdt로 환산하여 정정 수량 가능여부 확인
        coinDailyPlMn.orgUseUsdt = orgUseUsdt;
        coinDailyPlMn.useUsdt = useUsdt;
        coinDailyPlMn.ableUsdt = ableUsdt;

        if (this.modifyData.ordSdCd == "1"){ //매도
          maxSellBuyQty = Utils.getCoinOrdQty(coinDailyPlMn, coinLeverage, this.stdOrdPrc, cms, this.coinSymbolInfo.costDotCnt, coinTier, buffer); 
        }else if (this.modifyData.ordSdCd == "2"){ //매수
          maxSellBuyQty = Utils.getCoinOrdQty(coinDailyPlMn, coinLeverage, this.stdOrdPrc, cms, this.coinSymbolInfo.costDotCnt, coinTier, buffer);
        }

        if (this.stdOrdQty > maxSellBuyQty){
          window.$alert.alert('최대 주문 금액을 초과했습니다.', '알림');
          return;
        }
      }
      

      //가격 수량이 같으면 업데이트 안함
      if (this.stdOrdPrc != this.modifyData.execPrc || this.stdOrdQty != this.modifyData.balQty){
        this.modifyData.ordPrc = this.stdOrdPrc;
        this.modifyData.ordQty = this.stdOrdQty;
        this.$emit("modifyOrd", this.modifyData);
      }

      let message = "코인 체결리스트 미체결 정정 확인 클릭 "+ this.modifyData.symCd;
      this.sendCoinOmsLogMessage(message);

      this.closeModal();
    },
    sendCoinOmsLogMessage(message){ //코인 사용자 로그 저장
      window.$store.dispatch('SocketCoinOms/setLogMsg', {message:message});
    },
    //가격 입력시 체크
    checkEditOrdPrc(event){
      //현재 시세
      let curPrc = this.cocData.curPr.toFixed(this.tikDotSz(this.coinSymbol));

      this.stdOrdPrc = Utils.inputPointCoinPrc(event, "USDT", curPrc, this.coinSymbolInfo.costDotCnt);
    },
    //수량 입렵시 체크
    checkEditOrdQty(event){
      this.stdOrdQty = Utils.inputPointCoinQty(event, this.stdOrdType, this.coinSymbolInfo.costDotCnt, null, null, null);
    },
    tikDotSz(coinSymbol){
      if (coinSymbol == null){
        return 0;
      }
      return Utils.tikDotSz(coinSymbol);
    },
  },
};
</script>
<style lang="scss" scoped></style>
